module.exports = __webpack_public_path__ + "img/full1-min.db2cec10.png";